import { render, staticRenderFns } from "./AddOlympiadModal.vue?vue&type=template&id=e8a7e92c&"
import script from "./AddOlympiadModal.vue?vue&type=script&lang=js&"
export * from "./AddOlympiadModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOlympiadModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports